import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authSliceReducer, userSliceReducer , cartSliceReducer , seoSliceReducer } from "./Slices/Slice";
import {  siteSettingApi , FaqApi, seoApi , authApi, SliderApi, paymentsApi, productsApi, categoriesApi, ShoppingApi, RulesApi , userApi , aboutApi, blogsApi , orderApi , brandsApi , commentsApi , deliveryApi , cartApi} from "./Slices/Api";




// 1. کانفیگ پرسیست
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["userSlice", "authSlice" , "cartSlice"], // فقط userSlice پرسیست شود
};

// 2. کامباین ریدوسرها
const rootReducer = combineReducers({
  authSlice: authSliceReducer,
  userSlice: userSliceReducer,
  cartSlice: cartSliceReducer,
  seoSlice : seoSliceReducer ,
  
  
  [authApi.reducerPath]: authApi.reducer,
  [SliderApi.reducerPath]: SliderApi.reducer,
  [productsApi.reducerPath]: productsApi.reducer,
  [categoriesApi.reducerPath]: categoriesApi.reducer,
  [aboutApi.reducerPath]: aboutApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [deliveryApi.reducerPath]: deliveryApi.reducer,
  [blogsApi.reducerPath]: blogsApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
  [brandsApi.reducerPath] : brandsApi.reducer,
  [commentsApi.reducerPath] : commentsApi.reducer ,
  [cartApi.reducerPath] : cartApi.reducer ,
  [paymentsApi.reducerPath] : paymentsApi.reducer,
  [seoApi.reducerPath] : seoApi.reducer,
  [FaqApi.reducerPath] : FaqApi.reducer,
  [siteSettingApi.reducerPath] : siteSettingApi.reducer,
  [ShoppingApi.reducerPath] : ShoppingApi.reducer,
  [RulesApi.reducerPath] : RulesApi.reducer,


});

// 3. ساخت persistedReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 4. ساخت استور
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // مهم برای redux-persist
    }).concat(authApi.middleware)

  .concat(SliderApi.middleware)
  .concat(productsApi.middleware)
  .concat(aboutApi.middleware)
  .concat(userApi.middleware)
  .concat(deliveryApi.middleware)
  .concat(categoriesApi.middleware)
  .concat(blogsApi.middleware)
  .concat(orderApi.middleware)
  .concat(brandsApi.middleware)
  .concat(commentsApi.middleware)
  .concat(cartApi.middleware)
  .concat(paymentsApi.middleware)
  .concat(seoApi.middleware)
  .concat(FaqApi.middleware)
  .concat(RulesApi.middleware)
  .concat(ShoppingApi.middleware)
  .concat(siteSettingApi.middleware)
});

setupListeners(store.dispatch);

// 5. ساخت persistor
export const persistor = persistStore(store);
